module.exports = __webpack_public_path__ + "media/images/lb/677-155d4e96271b0a32a4a7b3e9f8a3ac4a.svg";